import React from "react";
import { Box, Divider, IconButton } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { changeStyle, setSatelliteOption } from "../../redux/slices/mapSlice";
import satelliteStreet from "../../assets/images/mapStyles/mapStyleSatelliteStreet.png";
import mapStreet from "../../assets/images/mapStyles/mapStyleStreet.png";
import mapNavigationDay from "../../assets/images/mapStyles/mapStyleNavigationDay.png";
import mapNavigationNight from "../../assets/images/mapStyles/mapStyleNavigationNight.png";
import mapLight from "../../assets/images/mapStyles/mapStyleLight.png";
import mapDark from "../../assets/images/mapStyles/mapStyleDark.png";
import { palette } from "../../themes/theme";
// import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import TungstenIcon from "@mui/icons-material/Tungsten";
import { ScrollItemWrapper, ScrollContainer } from "./mapStyledComponents";

const mapStylesData = [
  { id: "navigation-day-v1", label: "Navigation Day", image: mapNavigationDay },
  {
    id: "satellite-streets-v12",
    label: "Satellite Street",
    image: satelliteStreet,
  },
  { id: "streets-v12", label: "Streets", image: mapStreet },
  { id: "light-v11", label: "Light", image: mapLight },
  { id: "dark-v11", label: "Dark", image: mapDark },
  {
    id: "navigation-night-v1",
    label: "Navigation Night",
    image: mapNavigationNight,
  },
];

const MapStyles = ({ mapRef, setShowOpacityControl, resetAllOnceChanged }) => {
  const mapState = useSelector((state) => state.map);
  const activeMapStyle = useSelector((state) => state.map.mapStyle);
  const dispatch = useDispatch();

  const handleStyleChange = (e) => {
    if (!mapRef?.loaded?.()) return;
    setShowOpacityControl(false);
    dispatch(changeStyle(e.id));
    dispatch(setSatelliteOption(e.id === "satellite-streets-v12"));
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        // py: "5px",
        // px: "4px",
        // justifyContent: "space-evenly",
        // gap: 2,
        overflow: "auto",
      }}
    >
      <ScrollContainer
        variant="scrollable"
        value={0}
        scrollButtons
        allowScrollButtonsMobile
      >
        {mapStylesData.map((d, i) => (
          <ScrollItemWrapper
            key={i}
            elevation={d.id === activeMapStyle ? 5 : 2}
            onClick={() => handleStyleChange(d)}
          >
            <div
              className="map-style"
              style={{
                opacity: d.id === activeMapStyle && 1,
              }}
              //   onClick={() => handleStyleChange(d)}
            >
              <img
                src={d.image}
                alt={d.label}
                width={"45px"}
                style={{
                  border:
                    d.id === activeMapStyle
                      ? `2px solid ${palette.primary.main}`
                      : "",
                  borderRadius: "4px",
                }}
              />
              {/* <Typography sx={{ fontSize: 12, fontWeight: "500" }}>
                      {d.label}
                    </Typography> */}
            </div>
          </ScrollItemWrapper>
        ))}
      </ScrollContainer>
      <Divider orientation="vertical" sx={{ height: 40 }} />
      <IconButton
        sx={{
          // position: "absolute",
          rotate: "180deg",
          // bottom: 120,
          // right: 10,
          background: palette.background.light,
          borderRadius: 1,
          // boxShadow: "1px 3px 12px black",
          "&:hover": {
            background: palette.primary.main,
            transition: "all 0.35s ease-in-out",
          },
        }}
        disabled={!mapState.showSatelliteOption}
        onClick={() => {
          resetAllOnceChanged();
          setShowOpacityControl(true);
        }}
      >
        <TungstenIcon />
      </IconButton>
    </Box>
  );
};

export default MapStyles;
